import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const desktopTableColumns = [
  createColumn({
    keyName: "notes",
    header: () => i18next.t("patientPage_columns_note"),
    cell: (info) => info.renderValue(),
    size: 200,
  }),
  createColumn({
    keyName: "assignedTo",
    header: () => i18next.t("patientPage_columns_assigned_to"),
    cell: (info) => info.renderValue(),
    size: 120,
  }),
  createColumn({
    keyName: "complete",
    header: () => i18next.t("patientPage_columns_complete"),
    cell: (info) => info.renderValue(),
    size: 130,
  }),
  createColumn({
    keyName: "time",
    header: () => i18next.t("patientPage_columns_added"),
    cell: (info) => info.renderValue(),
    size: 130,
  }),
  createColumn({
    keyName: "priority",
    header: () => i18next.t("patientPage_columns_priority"),
    cell: (info) => info.renderValue(),
    size: 90,
  }),
  createColumn({
    keyName: "reviewedByEmail",
    header: () => i18next.t("patientPage_columns_created_by"),
    cell: (info) => info.renderValue(),
    size: 150,
  }),
  createColumn({
    keyName: "action",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
  }),
];
